import { Text } from '@consta/uikit/Text'
import cn from 'classnames'
import type { FC, PropsWithChildren } from 'react'

import css from './ShortcutTerm.css'

type ShortcutTermProps = {
  description: string
  className?: string
}

export const ShortcutTerm: FC<PropsWithChildren<ShortcutTermProps>> = ({
  children,
  description,
  className,
}) => {
  return (
    <>
      <Text size="xs" as="p" view="primary">
        {description}
      </Text>
      <Text className={cn(css.term, className)} size="xs" weight="regular">
        {children}
      </Text>
    </>
  )
}
